const actions = {
  SET_STATE: 'modals_windows/SET_STATE',
  SUBSCRIPTION: 'modals_windows/SUBSCRIPTION',
  RIGHT_SIDEBAR: 'modals_windows/RIGHT_SIDEBAR',
  SET_RIGHT_SIDEBAR_TAB: 'modals_windows/SET_RIGHT_SIDEBAR_TAB',
  LEGAL_MODAL: 'modals_windows/LEGAL_MODAL',
}

export default actions
